import reactComponentLoader from 'scripts/react-component-loader'

import { FraudNotification } from './'

reactComponentLoader(FraudNotification, '[data-fraud-notification]')
